import React from "react";
import FormControl from "@mui/material/FormControl";
import { MenuItem, Select } from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function LeaveType({
  registration,
  title,
  onSelected,
  selectedType,
}) {
  return (
    <div className="dropdown" id="leave-types-container">
      <p className="leave-type-title" id="leave-types-title">
        {title}
      </p>
      <FormControl sx={{ width: "100%" }} id="leave-types-from-control">
        <Select
          value={selectedType}
          onChange={onSelected}
          renderValue={(selected) => {
            return selected;
          }}
          MenuProps={MenuProps}
          inputProps={{ "aria-label": "Without label" }}
          id="leave-types-selector"
        >
          {registration.map((registration) => (
            <MenuItem
              key={registration.name ? registration.name : registration}
              value={registration.name ? registration.name : registration}
              id="leave-types-menu-item"
            >
              {registration.name ? registration.name : registration}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
